/**
 * Dynamically loads language-specific fonts based on locale
 */

export const FONT_CONFIGS = {
    km: { // Khmer
        id: 'khmer-font',
        href: 'https://fonts.googleapis.com/css2?family=Noto+Serif+Khmer:wght@100..900&display=swap'
    }
};

export function loadFontForLocale(locale: string): void {
    const config = FONT_CONFIGS[locale];
    
    if (!config) {
        return;
    }

    if (document.getElementById(config.id)) {
        return;
    }

    const link = document.createElement('link');
    link.id = config.id;
    link.rel = 'stylesheet';
    link.href = config.href;
    
    document.head.appendChild(link);
}

export function removeFontForLocale(locale: string): void {
    const config = FONT_CONFIGS[locale];
    
    if (!config) {
        return;
    }

    const existingLink = document.getElementById(config.id);
    if (existingLink) {
        existingLink.remove();
    }
}
